//修改保存成功
<template>
    <div id="success">
       <p v-if="loading === 'loading'">
           <i class="el-icon-loading"></i>
           <span>验证中...</span>
       </p>
       <p v-if="loading === 'success'">
           <i class="el-icon-success"></i>
           <span>信息修改成功！</span>
       </p>
       <p v-if="loading === 'error'">
           <i class="el-icon-error"></i>
           <span>链接已失效</span>
       </p>
       <router-link :to="{name: 'pcibLogin'}" v-if="loading !== 'loading'">前往登录</router-link>
    </div>
</template>

<script>
import { post } from '@/util/http';
export default {
  name: 'change-success',
  props: {
  },
  watch: {
    
  },
  created() {
    let self = this;
    post('user/userinfo/change/confirm/', {
      "token": self.$route.query.token,
      "uid": self.$route.query.uid
    }).then( res => {
      self.loading = 'success';
    }, err => {
      self.loading = 'error';
    })
  },
  data () {
    return {
      loading: "loading"
    }
  },
  methods: {
    
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/mirrors/auths/ChangeSuccess.vue